// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .container {
  height: 100%;
}
:host .panel-header {
  width: 100%;
  display: block;
}
:host .panel-footer {
  float: left;
  height: 22px;
  font-family: monospace;
}
:host .panel-function {
  display: inline-block;
  width: calc(100% - 90px);
  margin-top: 10px;
  font-family: monospace;
}
:host .panel-toolbar {
  float: right;
}
:host .panel-code {
  width: 100%;
  --tab-height: 30px;
}
:host .system-function button {
  width: 100%;
  font-size: 12px !important;
  font-weight: 100 !important;
  margin-top: 2px;
  margin-bottom: 2px;
  background-color: #424242;
  color: white;
}
:host .test-parameters {
  display: block;
  font-size: 12px;
  padding: 5px 5px 5px 5px;
}
:host .test-console {
  display: block;
  font-size: 12px;
  /* background-color: black; */
  /* color: white; */
  padding-left: 5px;
  border-top: 1px solid #2D3335;
}
:host .test-parameters .header {
  line-height: 24px;
  width: 100%;
}
:host .test-parameters .content {
  overflow: auto;
}
:host .content .my-form-field {
  margin-top: 5px;
}
:host .content .content-input {
  width: 220px;
  background-color: #242b2e;
}
:host .content .content-button {
  margin-left: 10px;
  height: 27px;
}
:host .test-panel {
  overflow: auto;
  position: relative;
}
:host .test-panel .test-button {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
:host .test-console .header {
  line-height: 20px;
  width: 100%;
}
:host .small-icon-button {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
:host .small-icon-button .mat-icon {
  width: 20px;
  height: 20px;
  line-height: 20px;
}
:host .small-icon-button .material-icons {
  font-size: 16px;
}
:host .console-text {
  display: block;
  line-height: 14px;
  white-space: nowrap;
}
:host ::ng-deep .mat-tab-label {
  height: var(--tab-height) !important;
  color: white;
  padding-left: 10px !important;
  padding-right: 10px !important;
  min-width: 100px;
}
:host ::ng-deep .cm-system-function {
  color: greenyellow;
}
@media screen and (max-height: 1500px) {
  :host ::ng-deep .CodeMirror {
    height: 600px;
  }
  :host .test-panel {
    height: calc(299px - var(--tab-height) / 2);
  }
}
@media screen and (max-height: 960px) {
  :host ::ng-deep .CodeMirror {
    height: 600px;
  }
  :host .test-panel {
    height: calc(299px - var(--tab-height) / 2);
  }
}
@media screen and (max-height: 920px) {
  :host ::ng-deep .CodeMirror {
    height: 540px;
  }
  :host .test-panel {
    height: calc(269px - var(--tab-height) / 2);
  }
}
@media screen and (max-height: 870px) {
  :host ::ng-deep .CodeMirror {
    height: 480px;
  }
  :host .test-panel {
    height: calc(239px - var(--tab-height) / 2);
  }
}
@media screen and (max-height: 820px) {
  :host ::ng-deep .CodeMirror {
    height: 400px;
  }
  :host .test-panel {
    height: calc(199px - var(--tab-height) / 2);
  }
}
@media screen and (max-height: 720px) {
  :host ::ng-deep .CodeMirror {
    height: 300px;
  }
  :host .test-panel {
    height: calc(149px - var(--tab-height) / 2);
  }
}
:host .side-panel {
  background-color: #333a3c;
  color: rgb(255, 255, 255);
}
:host .side-panel-header {
  font-size: 15px;
  margin-top: 5px;
  line-height: 25px;
  margin-bottom: 5px;
}
:host .side-toggle {
  transform-origin: center center;
  transition: all 0.3s ease-in-out;
}
:host .side-toggle-expand {
  transform: rotate(0deg);
}
:host .side-toggle-collapse {
  transform: rotate(180deg);
}
:host .function-text {
  color: rgb(0, 110, 255);
  line-height: 25px;
}
:host .mychips {
  display: inline-block;
  font-size: inherit;
  height: 26px;
  line-height: 24px;
  border-radius: 13px;
  background-color: var(--chipsBackground);
  cursor: pointer;
  font-family: monospace;
  vertical-align: middle;
  margin-left: 2px;
  margin-right: 2px;
}
:host .mychips mat-icon {
  margin: 3px 3px 4px 2px;
  opacity: 0.5;
  font-size: 20px;
  text-align: center;
}
:host .mychips span {
  padding-left: 3px;
  padding-right: 13px;
  vertical-align: top;
}

.code-menu-sync-select mat-icon {
  font-size: 18px;
  margin-right: unset !important;
}
.code-menu-sync-select span {
  line-height: 20px;
  margin-right: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/scripts/script-editor/script-editor.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/scripts/script-editor/script-editor.component.scss"],"names":[],"mappings":"AAEI;EACI,YAAA;ACDR;ADII;EACI,WAAA;EACA,cAAA;ACFR;ADKI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;ACHR;ADMI;EACI,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;ACJR;ADOI;EACI,YAAA;ACLR;ADQI;EACI,WAAA;EACA,kBAAA;ACNR;ADSI;EACI,WAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;ACPR;ADUI;EACI,cAAA;EACA,eAAA;EACA,wBAAA;ACRR;ADWI;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;ACTR;ADYI;EACI,iBAAA;EACA,WAAA;ACVR;ADaI;EACI,cAAA;ACXR;ADcI;EACI,eAAA;ACZR;ADeI;EACI,YAAA;EACA,yBAAA;ACbR;ADgBI;EACI,iBAAA;EACA,YAAA;ACdR;ADiBI;EACI,cAAA;EACA,kBAAA;ACfR;ADkBI;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AChBR;ADmBI;EACI,iBAAA;EACA,WAAA;ACjBR;ADwBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACtBR;ADyBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ACvBR;AD0BI;EACI,eAAA;ACxBR;AD2BI;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;ACzBR;AD4BI;EACI,oCAAA;EACA,YAAA;EACA,6BAAA;EACA,8BAAA;EACA,gBAAA;AC1BR;AD6BI;EACI,kBAAA;AC3BR;AD8BI;EACI;IACI,aAAA;EC5BV;ED8BM;IACI,2CAAA;EC5BV;AACF;AD+BI;EACI;IACI,aAAA;EC7BV;ED+BM;IACI,2CAAA;EC7BV;AACF;ADgCI;EACI;IACI,aAAA;EC9BV;EDgCM;IACI,2CAAA;EC9BV;AACF;ADiCI;EACI;IACI,aAAA;EC/BV;EDiCM;IACI,2CAAA;EC/BV;AACF;ADkCI;EACI;IACI,aAAA;EChCV;EDkCM;IACI,2CAAA;EChCV;AACF;ADmCI;EACI;IACI,aAAA;ECjCV;EDmCM;IACI,2CAAA;ECjCV;AACF;ADoCI;EACI,yBAAA;EACA,yBAAA;AClCR;ADqCI;EACI,eAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ACnCR;ADsCI;EACI,+BAAA;EAIA,gCAAA;ACpCR;ADuCI;EACI,uBAAA;ACrCR;ADwCI;EACI,yBAAA;ACtCR;ADyCI;EACI,uBAAA;EACA,iBAAA;ACvCR;AD0CI;EACI,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,eAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;ACxCR;AD2CI;EACI,uBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ACzCR;AD4CI;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;AC1CR;;ADgDI;EACI,eAAA;EACA,8BAAA;AC7CR;ADgDI;EACI,iBAAA;EACA,kBAAA;AC9CR","sourcesContent":["\n:host {\n    .container {\n        height: 100%;\n    }\n    \n    .panel-header {\n        width: 100%;\n        display: block;\n    }\n    \n    .panel-footer {\n        float: left;\n        height: 22px;\n        font-family: monospace;\n    }\n    \n    .panel-function {\n        display: inline-block;\n        width: calc(100% - 90px);\n        margin-top: 10px;\n        font-family: monospace;\n    }\n    \n    .panel-toolbar {\n        float: right;\n    }\n    \n    .panel-code {\n        width: 100%;\n        --tab-height: 30px;\n    }\n    \n    .system-function button {\n        width: 100%;\n        font-size: 12px !important;\n        font-weight: 100 !important;\n        margin-top: 2px;\n        margin-bottom: 2px;\n        background-color: #424242;\n        color: white;\n    }\n    \n    .test-parameters {\n        display: block;\n        font-size: 12px;\n        padding: 5px 5px 5px 5px;\n    }\n    \n    .test-console {\n        display: block;\n        font-size: 12px;\n        /* background-color: black; */\n        /* color: white; */\n        padding-left: 5px;\n        border-top: 1px solid #2D3335;\n    }\n    \n    .test-parameters .header {\n        line-height: 24px;\n        width: 100%;\n    }\n    \n    .test-parameters .content {\n        overflow: auto;\n    }\n    \n    .content .my-form-field {\n        margin-top: 5px;\n    }\n    \n    .content .content-input {\n        width: 220px;\n        background-color: #242b2e;\n    }\n    \n    .content .content-button {\n        margin-left: 10px;\n        height: 27px;\n    }\n    \n    .test-panel {\n        overflow: auto;\n        position: relative;\n    }\n    \n    .test-panel .test-button {\n        position: absolute;\n        bottom: 5px;\n        right: 5px;\n    }\n    \n    .test-console .header {\n        line-height: 20px;\n        width: 100%;\n    }\n    \n    .test-console .content {\n    }\n    \n    \n    .small-icon-button {\n        width: 24px;\n        height: 24px;\n        line-height: 24px;\n    }\n    \n    .small-icon-button .mat-icon {\n        width: 20px;\n        height: 20px;\n        line-height: 20px;\n    }\n    \n    .small-icon-button .material-icons {\n        font-size: 16px;\n    }\n    \n    .console-text {\n        display: block;\n        line-height: 14px;\n        white-space: nowrap;\n    }\n    \n    ::ng-deep .mat-tab-label {\n        height: var(--tab-height) !important;\n        color: white;\n        padding-left: 10px !important;\n        padding-right: 10px !important;\n        min-width: 100px;\n    }\n    \n    ::ng-deep .cm-system-function {\n        color: greenyellow;\n    }\n    \n    @media screen and (max-height: 1500px) {\n        ::ng-deep .CodeMirror{\n            height: 600px;\n        }\n        .test-panel {\n            height: calc(299px - var(--tab-height) / 2);\n        }\n    }\n    \n    @media screen and (max-height: 960px) {\n        ::ng-deep .CodeMirror{\n            height: 600px;\n        }\n        .test-panel {\n            height: calc(299px - var(--tab-height) / 2);\n        }\n    }\n    \n    @media screen and (max-height: 920px) {\n        ::ng-deep .CodeMirror{\n            height: 540px;\n        }\n        .test-panel {\n            height: calc(269px - var(--tab-height) / 2);\n        }\n    }\n    \n    @media screen and (max-height: 870px) {\n        ::ng-deep .CodeMirror{\n            height: 480px;\n        }\n        .test-panel {\n            height: calc(239px - var(--tab-height) / 2);\n        }\n    }\n    \n    @media screen and (max-height: 820px) {\n        ::ng-deep .CodeMirror{\n            height: 400px;\n        }\n        .test-panel {\n            height: calc(199px - var(--tab-height) / 2);\n        }\n    }\n    \n    @media screen and (max-height: 720px) {\n        ::ng-deep .CodeMirror{\n            height: 300px;\n        }\n        .test-panel {\n            height: calc(149px - var(--tab-height) / 2);\n        }\n    }\n    \n    .side-panel {\n        background-color: #333a3c;\n        color: rgb(255, 255, 255);\n    }\n    \n    .side-panel-header {\n        font-size: 15px;\n        margin-top: 5px;\n        line-height: 25px;\n        margin-bottom: 5px;\n    }\n    \n    .side-toggle {\n        transform-origin: center center;\n        -webkit-transition: all 0.3s ease-in-out;\n        -moz-transition: all 0.3s ease-in-out;\n        -o-transition: all 0.3s ease-in-out;\n        transition: all 0.3s ease-in-out;\n    }\n    \n    .side-toggle-expand {\n        transform: rotate(0deg);\n    }\n    \n    .side-toggle-collapse {\n        transform: rotate(180deg);\n    }\n    \n    .function-text {\n        color:rgb(0, 110, 255);\n        line-height: 25px;\n    }\n    \n    .mychips {\n        display: inline-block;\n        font-size: inherit;\n        height: 26px;\n        line-height: 24px;\n        border-radius: 13px;\n        background-color: var(--chipsBackground);\n        cursor: pointer;\n        font-family: monospace;\n        vertical-align: middle;\n        margin-left: 2px;\n        margin-right: 2px;\n    }\n    \n    .mychips mat-icon {\n        margin: 3px 3px 4px 2px;\n        opacity: 0.5;\n        font-size: 20px;\n        text-align: center;\n    }\n    \n    .mychips span {\n        padding-left: 3px;\n        padding-right: 13px;\n        vertical-align: top;\n    }\n}\n\n.code-menu-sync-select {\n\n    mat-icon {\n        font-size: 18px;\n        margin-right: unset !important;\n    }\n\n    span {\n        line-height: 20px;\n        margin-right: 25px;\n    }\n}\n",":host .container {\n  height: 100%;\n}\n:host .panel-header {\n  width: 100%;\n  display: block;\n}\n:host .panel-footer {\n  float: left;\n  height: 22px;\n  font-family: monospace;\n}\n:host .panel-function {\n  display: inline-block;\n  width: calc(100% - 90px);\n  margin-top: 10px;\n  font-family: monospace;\n}\n:host .panel-toolbar {\n  float: right;\n}\n:host .panel-code {\n  width: 100%;\n  --tab-height: 30px;\n}\n:host .system-function button {\n  width: 100%;\n  font-size: 12px !important;\n  font-weight: 100 !important;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  background-color: #424242;\n  color: white;\n}\n:host .test-parameters {\n  display: block;\n  font-size: 12px;\n  padding: 5px 5px 5px 5px;\n}\n:host .test-console {\n  display: block;\n  font-size: 12px;\n  /* background-color: black; */\n  /* color: white; */\n  padding-left: 5px;\n  border-top: 1px solid #2D3335;\n}\n:host .test-parameters .header {\n  line-height: 24px;\n  width: 100%;\n}\n:host .test-parameters .content {\n  overflow: auto;\n}\n:host .content .my-form-field {\n  margin-top: 5px;\n}\n:host .content .content-input {\n  width: 220px;\n  background-color: #242b2e;\n}\n:host .content .content-button {\n  margin-left: 10px;\n  height: 27px;\n}\n:host .test-panel {\n  overflow: auto;\n  position: relative;\n}\n:host .test-panel .test-button {\n  position: absolute;\n  bottom: 5px;\n  right: 5px;\n}\n:host .test-console .header {\n  line-height: 20px;\n  width: 100%;\n}\n:host .small-icon-button {\n  width: 24px;\n  height: 24px;\n  line-height: 24px;\n}\n:host .small-icon-button .mat-icon {\n  width: 20px;\n  height: 20px;\n  line-height: 20px;\n}\n:host .small-icon-button .material-icons {\n  font-size: 16px;\n}\n:host .console-text {\n  display: block;\n  line-height: 14px;\n  white-space: nowrap;\n}\n:host ::ng-deep .mat-tab-label {\n  height: var(--tab-height) !important;\n  color: white;\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n  min-width: 100px;\n}\n:host ::ng-deep .cm-system-function {\n  color: greenyellow;\n}\n@media screen and (max-height: 1500px) {\n  :host ::ng-deep .CodeMirror {\n    height: 600px;\n  }\n  :host .test-panel {\n    height: calc(299px - var(--tab-height) / 2);\n  }\n}\n@media screen and (max-height: 960px) {\n  :host ::ng-deep .CodeMirror {\n    height: 600px;\n  }\n  :host .test-panel {\n    height: calc(299px - var(--tab-height) / 2);\n  }\n}\n@media screen and (max-height: 920px) {\n  :host ::ng-deep .CodeMirror {\n    height: 540px;\n  }\n  :host .test-panel {\n    height: calc(269px - var(--tab-height) / 2);\n  }\n}\n@media screen and (max-height: 870px) {\n  :host ::ng-deep .CodeMirror {\n    height: 480px;\n  }\n  :host .test-panel {\n    height: calc(239px - var(--tab-height) / 2);\n  }\n}\n@media screen and (max-height: 820px) {\n  :host ::ng-deep .CodeMirror {\n    height: 400px;\n  }\n  :host .test-panel {\n    height: calc(199px - var(--tab-height) / 2);\n  }\n}\n@media screen and (max-height: 720px) {\n  :host ::ng-deep .CodeMirror {\n    height: 300px;\n  }\n  :host .test-panel {\n    height: calc(149px - var(--tab-height) / 2);\n  }\n}\n:host .side-panel {\n  background-color: #333a3c;\n  color: rgb(255, 255, 255);\n}\n:host .side-panel-header {\n  font-size: 15px;\n  margin-top: 5px;\n  line-height: 25px;\n  margin-bottom: 5px;\n}\n:host .side-toggle {\n  transform-origin: center center;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n:host .side-toggle-expand {\n  transform: rotate(0deg);\n}\n:host .side-toggle-collapse {\n  transform: rotate(180deg);\n}\n:host .function-text {\n  color: rgb(0, 110, 255);\n  line-height: 25px;\n}\n:host .mychips {\n  display: inline-block;\n  font-size: inherit;\n  height: 26px;\n  line-height: 24px;\n  border-radius: 13px;\n  background-color: var(--chipsBackground);\n  cursor: pointer;\n  font-family: monospace;\n  vertical-align: middle;\n  margin-left: 2px;\n  margin-right: 2px;\n}\n:host .mychips mat-icon {\n  margin: 3px 3px 4px 2px;\n  opacity: 0.5;\n  font-size: 20px;\n  text-align: center;\n}\n:host .mychips span {\n  padding-left: 3px;\n  padding-right: 13px;\n  vertical-align: top;\n}\n\n.code-menu-sync-select mat-icon {\n  font-size: 18px;\n  margin-right: unset !important;\n}\n.code-menu-sync-select span {\n  line-height: 20px;\n  margin-right: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
